import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Variation from '../Variation';
import Icon from '../Icon';

const Stamp = ({ title, value, variation, size = 4, truncate = true, className, extraInfo }) => {
  const extraInfoText = extraInfo
    ? Object.entries(extraInfo).map(([key, value]) => `${key}: ${value}`).join('\n')
    : '';

  const drawVariation = () => {
    // variation can be '0' which is falsy
    if (variation !== null && variation !== undefined) {
      return (
        <Variation variation={variation} />
      );
    }
  };

  return (
    <div className={cx(className, 'is-block', { 'truncate': truncate })}>
      <h3 className="has-text-weight-bold has-text-light">
        {title}
      </h3>
      <div className="is-flex is-justify-content-space-between">
        <p className={cx(`is-size-${size}`, { 'truncate': truncate })}>
          {value !== null && value !== undefined && value !== '' ? value : 'N/A'}
        </p>
        {drawVariation()}
        {extraInfoText !== '' && (
          <span
            className="is-flex-shrink-0 has-tooltip-left"
            data-tooltip={extraInfoText}
            aria-label={extraInfoText}
          >
            <Icon icon="fa-info-circle" size="small" color="grey" />
          </span>
        )}
      </div>
    </div>
  );
};

Stamp.propTypes = {
  title: PropTypes.string,
  value: PropTypes.any,
  size: PropTypes.any,
  truncate: PropTypes.bool,
  variation: PropTypes.number,
  className: PropTypes.string,
  extraInfo: PropTypes.object,
};

export default Stamp;
